import { render, staticRenderFns } from "./HeaderNews.vue?vue&type=template&id=76a800be&scoped=true"
import script from "./HeaderNews.vue?vue&type=script&lang=js"
export * from "./HeaderNews.vue?vue&type=script&lang=js"
import style0 from "./HeaderNews.vue?vue&type=style&index=0&id=76a800be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a800be",
  null
  
)

export default component.exports